export default __webpack_public_path__ + "static/media/lebron_banner_highlight.488f86e5.png";